import dataCables from './cables_cables';
import dataPoints from './points_data';

const data = {
	data: dataPoints,
	pops: dataPoints.filter((d) => d.pop),
	landing: dataPoints.filter((d) => d.ls),
	cables: dataCables
};

const layers = [
	{
		title: 'Network map',
		type: 'none',
		data: [],
		layer: 'network',
		prefix: '',
		desc: 'Global View',
	},
	{
		title: 'Submarine cables',
		type: 'cable',
		data: data.cables,
		layer: 'cables',
		prefix: 'm-cables-',
		desc: '',
		sub: '',
		sub2: '',
		sub3: ''
	},
	{
		title: 'IP',
		type: 'location',
		data: [].concat(data.data.filter((pop) => pop.internet)).sort((a, b) => (a.name > b.name ? 1 : -1)),
		layer: 'ip',
		prefix: 'm-ip-',
		desc: '61 PoPs',
		sub: '61 PoPs',
		sub2: '',
		sub3: ''
	},
	{
		title: 'Capacity',
		type: 'location',
		data: [].concat(data.data.filter((pop) => pop.capacity)).sort((a, b) => (a.name > b.name ? 1 : -1)),
		layer: 'capacity',
		prefix: 'm-capa-',
		desc: '63 PoPs',
		sub: '63 PoPs',
		sub2: '',
		sub3: ''
	},
	{
		title: 'Colocation',
		type: 'location',
		data: [].concat(data.data.filter((pop) => pop.colocation)).sort((a, b) => (a.name > b.name ? 1 : -1)),
		layer: 'colocation',
		prefix: 'm-colo-',
		desc: '27 PoPs',
		sub: '27 PoPs',
		sub2: '',
		sub3: ''
	}
];

export default layers;
